module.exports = __webpack_public_path__ + "static/media/arrow-back-black.818b98f5.svg";